module.exports = __webpack_public_path__ + "static/media/schedule_feature@3x.5e37627c.svg";